import swError from './index.vue'
swError.install = function (Vue) {
  Vue.component(swError.name, swError)
}

export default swError
